import { useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2, X, Star, ArrowLeft } from "lucide-react";
import { api, API } from "../lib/api";

export default function PhotoUploader({ photos, onChange, max = 8, kind = "car" }) {
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const files = Array.from(e.target.files || []).slice(0, max - photos.length);
    e.target.value = "";
    if (files.length === 0) return;
    setBusy(true);
    const added = [];
    for (const f of files) {
      if (f.size > 10 * 1024 * 1024) { toast.error(`${f.name} exceeds 10 MB`); continue; }
      try {
        const fd = new FormData(); fd.append("file", f);
        const { data } = await api.post(`/uploads?kind=${kind}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
        added.push(`${API}/files/${data.path}`);
      } catch (err) { toast.error(err?.response?.data?.detail || `Upload failed: ${f.name}`); }
    }
    if (added.length) { onChange([...photos, ...added]); toast.success(`${added.length} photo${added.length > 1 ? "s" : ""} uploaded`); }
    setBusy(false);
  };

  const remove = (i) => onChange(photos.filter((_, idx) => idx !== i));
  const makeHero = (i) => onChange([photos[i], ...photos.filter((_, idx) => idx !== i)]);

  return (
    <div data-testid="photo-uploader">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {photos.map((p, i) => (
          <div key={p} className="relative aspect-[4/3] rounded-xl overflow-hidden bg-slate-900 border border-slate-800 group" data-testid={`photo-tile-${i}`}>
            <img src={p} alt="" className="w-full h-full object-cover" />
            {i === 0 && <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-cyan-500 text-slate-950 text-[10px] font-bold flex items-center gap-1"><Star className="w-3 h-3" />HERO</span>}
            <div className="absolute inset-0 bg-slate-950/70 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
              {i !== 0 && <button type="button" onClick={() => makeHero(i)} data-testid={`photo-hero-${i}`} className="p-2 rounded-lg bg-slate-800 hover:bg-cyan-500 hover:text-slate-950" title="Make hero"><ArrowLeft className="w-4 h-4" /></button>}
              <button type="button" onClick={() => remove(i)} data-testid={`photo-remove-${i}`} className="p-2 rounded-lg bg-slate-800 hover:bg-red-500" title="Remove"><X className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
        {photos.length < max && (
          <label className="aspect-[4/3] rounded-xl border border-dashed border-slate-700 bg-slate-900/50 hover:border-cyan-500/60 cursor-pointer flex flex-col items-center justify-center gap-2 text-slate-400 text-xs transition-colors" data-testid="photo-add-tile">
            {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <><Upload className="w-5 h-5" /><span>Add photos</span></>}
            <input type="file" multiple accept="image/*" className="hidden" onChange={pick} disabled={busy} data-testid="photo-input" />
          </label>
        )}
      </div>
      <p className="text-xs text-slate-500 mt-2">{photos.length}/{max} photos · first photo is the listing hero · JPG/PNG/WebP up to 10 MB</p>
    </div>
  );
}
